import axios from 'axios'
import interceptors from './interceptors'
import { apiUrl } from '../../config'
import localforage from 'localforage'
import { isEmpty } from 'lodash'
import { userTokenStorageKey } from 'src/config'
// allow use http client without Vue instance
export const http = axios.create({
  baseURL: apiUrl,
})

// Bind all functions and properties of axios to the http instance
for (const key in axios) {
  if (typeof axios[key] === 'function') {
    http[key] = axios[key].bind(http);
  } else {
    http[key] = axios[key];
  }
}

http.defaults.baseURL=apiUrl;
http.CancelToken = axios.CancelToken;
http.isCancel = axios.isCancel;
/**
* Helper method to set the header with the token
*/
export function setToken(token) {
  http.defaults.headers.common.Authorization = `Bearer ${token}`
}

// receive store and data by options
// https://vuejs.org/v2/guide/plugins.html
export default function install(Vue, { store, router }) {



  interceptors(http, store, router)
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
  Object.defineProperty(Vue.prototype, '$http', {

    get() {
      return http
    },
  })
}



// WEBPACK FOOTER //
// ./src/plugins/http/index.js